export default __webpack_public_path__ + "static/background-dc041d1697133f2a80e4d22703210a99.jpg";